// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  display: flex;
  column-gap: 20px;
}
.navigation__link {
  color: black;
  font-size: 18px;
  padding-bottom: 5px;
  border-bottom: 1px solid black;
}
.navigation__link:hover {
  color: rgba(12, 122, 231, 0.4);
  border-bottom: 1px solid rgba(12, 122, 231, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,8BAAA;EACA,gDAAA;AACN","sourcesContent":[".navigation {\n  display: flex;\n  column-gap: 20px;\n\n  &__link {\n    color: black;\n    font-size: 18px;\n    padding-bottom: 5px;\n    border-bottom: 1px solid black;\n\n    &:hover {\n      color: rgba(12 122 231 / 0.4);\n      border-bottom: 1px solid rgba(12 122 231 / 0.4);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
